import { TextField, Checkbox, FormControlLabel, Grid } from '@mui/material';
import { PlaceFormData } from '@/hooks/usePlaceForm';

interface EquipmentFieldsProps {
  formData: PlaceFormData;
  onChange: (name: string, value: any) => void;
}

export const EquipmentFields = ({ formData, onChange }: EquipmentFieldsProps) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <FormControlLabel
          control={
            <Checkbox
              name="personal_equipment_required"
              checked={formData.equipment.personal_equipment_required}
              onChange={(e) =>
                onChange('equipment.personal_equipment_required', e.target.checked)
              }
            />
          }
          label="Personal Equipment Required"
        />
      </Grid>
      <Grid item xs={6}>
        <FormControlLabel
          control={
            <Checkbox
              name="equipment_offered"
              checked={formData.equipment.equipment_offered}
              onChange={(e) => onChange('equipment.equipment_offered', e.target.checked)}
            />
          }
          label="Equipment Offered"
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Equipment Description"
          name="equipment_description"
          value={formData.equipment.equipment_description}
          onChange={(e) => onChange('equipment.equipment_description', e.target.value)}
          fullWidth
          multiline
          rows={4}
          margin="normal"
          sx={{
            '& .MuiOutlinedInput-root': {
              '&:hover fieldset': { borderColor: 'primary.main' },
              '&.Mui-focused fieldset': { borderWidth: 2, borderColor: 'primary.main' },
            },
          }}
        />
      </Grid>
    </Grid>
  );
};
